<div class="container">
  <i [ngClass]="color" class="fas {{icon}}"></i>
  <div class="header">
    <h2>{{title}}</h2>
    <p>{{message}}</p>
  </div>
  <app-button [text]="buttonText" [loading]="buttonLoading" (clickEvent)="handleButtonClick()"></app-button>
</div>